var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 203,
    viewBox: "0 0 174 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10157_310414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.9854 182.024C130.856 182.024 167.23 145.669 167.23 100.824C167.23 55.978 130.856 19.6235 85.9854 19.6235C41.1149 19.6235 4.74023 55.978 4.74023 100.824C4.74023 145.669 41.1149 182.024 85.9854 182.024Z",
    fill: "url(#paint0_linear_10157_310414)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10157_310414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.328 43.9834H20.3123C18.0687 43.9834 16.25 45.8011 16.25 48.0434V97.4401C16.25 99.6823 18.0687 101.5 20.3123 101.5H108.328C110.571 101.5 112.39 99.6823 112.39 97.4401V48.0434C112.39 45.8011 110.571 43.9834 108.328 43.9834Z",
    fill: "#1ABB78",
    fillOpacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10157_310414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.1708 49.3965H30.4666C28.223 49.3965 26.4043 51.2142 26.4043 53.4565V87.2898C26.4043 89.5321 28.223 91.3498 30.4666 91.3498H98.1708C100.414 91.3498 102.233 89.5321 102.233 87.2898V53.4565C102.233 51.2142 100.414 49.3965 98.1708 49.3965Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.6111 59.5469H57.5488V63.6069H61.6111V59.5469Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0584 59.5469H64.9961V63.6069H69.0584V59.5469Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5056 59.5469H72.4434V63.6069H76.5056V59.5469Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9529 59.5469H79.8906V63.6069H83.9529V59.5469Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4001 59.5469H87.3379V63.6069H91.4001V59.5469Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2693 65.6367H35.207V69.6967H39.2693V65.6367Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7166 65.6367H42.6543V69.6967H46.7166V65.6367Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1638 65.6367H50.1016V69.6967H54.1638V65.6367Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6111 65.6367H57.5488V69.6967H61.6111V65.6367Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0584 65.6367H64.9961V69.6967H69.0584V65.6367Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5056 65.6367H72.4434V69.6967H76.5056V65.6367Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9529 65.6367H79.8906V69.6967H83.9529V65.6367Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4001 65.6367H87.3379V69.6967H91.4001V65.6367Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2693 71.7266H35.207V75.7866H39.2693V71.7266Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7166 71.7266H42.6543V75.7866H46.7166V71.7266Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1638 71.7266H50.1016V75.7866H54.1638V71.7266Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6111 71.7266H57.5488V75.7866H61.6111V71.7266Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0584 71.7266H64.9961V75.7866H69.0584V71.7266Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5056 71.7266H72.4434V75.7866H76.5056V71.7266Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9529 71.7266H79.8906V75.7866H83.9529V71.7266Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4001 71.7266H87.3379V75.7866H91.4001V71.7266Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2693 77.8169H35.207V81.8769H39.2693V77.8169Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7166 77.8169H42.6543V81.8769H46.7166V77.8169Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1638 77.8169H50.1016V81.8769H54.1638V77.8169Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6111 77.8169H57.5488V81.8769H61.6111V77.8169Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0584 77.8169H64.9961V81.8769H69.0584V77.8169Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5056 77.8169H72.4434V81.8769H76.5056V77.8169Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9529 77.8169H79.8906V81.8769H83.9529V77.8169Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3195 98.7932C65.8152 98.7932 67.0277 97.5813 67.0277 96.0865C67.0277 94.5918 65.8152 93.3799 64.3195 93.3799C62.8238 93.3799 61.6113 94.5918 61.6113 96.0865C61.6113 97.5813 62.8238 98.7932 64.3195 98.7932Z",
    fill: "#DCE0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.892 115.033H48.748L50.5614 101.5H78.0789L79.892 115.033Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2757 118.417H45.3613C45.373 117.523 45.7539 116.669 46.4225 116.037C47.091 115.404 47.9944 115.044 48.9399 115.033H79.6969C80.6427 115.044 81.5459 115.404 82.2148 116.037C82.883 116.669 83.2642 117.523 83.2757 118.417Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.226 156.912C112.032 156.912 119.288 154.552 125.315 150.506L149.979 174.037L158.924 163.664L135.124 140.957C139.519 134.775 142.103 127.217 142.103 119.056C142.103 98.1487 125.145 81.2002 104.226 81.2002C83.3075 81.2002 66.3496 98.1487 66.3496 119.056C66.3496 139.963 83.3075 156.912 104.226 156.912ZM136.533 119.052C136.533 136.752 122.175 151.101 104.466 151.101C86.7557 151.101 72.3986 136.752 72.3986 119.052C72.3986 101.352 86.7557 87.0033 104.466 87.0033C122.175 87.0033 136.533 101.352 136.533 119.052Z",
    fill: "#1ABB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.464 151.725C122.705 151.725 137.493 137.082 137.493 119.018C137.493 100.954 122.705 86.311 104.464 86.311C86.223 86.311 71.4355 100.954 71.4355 119.018C71.4355 137.082 86.223 151.725 104.464 151.725Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.977 174.042L158.922 163.669L160.269 164.955C161.576 166.202 162.358 167.944 162.444 169.798C162.53 171.652 161.913 173.466 160.727 174.841C159.541 176.216 157.884 177.039 156.122 177.13C154.359 177.22 152.634 176.57 151.327 175.323L149.98 174.038L149.977 174.042Z",
    fill: "#1ABB78"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_10157_310414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.945 43.9834H123.268C121.373 43.9834 119.836 45.5996 119.836 47.5933V67.7033C119.836 69.6967 121.373 71.3133 123.268 71.3133H163.945C165.84 71.3133 167.377 69.6967 167.377 67.7033V47.5933C167.377 45.5996 165.84 43.9834 163.945 43.9834Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.992 61.9667C132.236 61.9667 134.054 60.149 134.054 57.9067C134.054 55.6644 132.236 53.8467 129.992 53.8467C127.748 53.8467 125.93 55.6644 125.93 57.9067C125.93 60.149 127.748 61.9667 129.992 61.9667Z",
    fill: "#CCC6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.074 53.8467H143.533C141.289 53.8467 139.471 55.6644 139.471 57.9067C139.471 60.149 141.289 61.9667 143.533 61.9667H157.074C159.317 61.9667 161.136 60.149 161.136 57.9067C161.136 55.6644 159.317 53.8467 157.074 53.8467Z",
    fill: "#1ABB78",
    fillOpacity: 0.56
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10157_310414",
    x: -13.75,
    y: 33.9834,
    width: 156.141,
    height: 117.517,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10157_310414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10157_310414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10157_310414",
    x: -3.5957,
    y: 39.3965,
    width: 135.828,
    height: 101.953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10157_310414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10157_310414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_10157_310414",
    x: 112.836,
    y: 34.9834,
    width: 73.541,
    height: 53.3301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10157_310414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10157_310414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10157_310414",
    x1: 85.3591,
    y1: -6.81714,
    x2: 87.0214,
    y2: 278.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10157_310414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 203,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarImg);
export default __webpack_public_path__ + "static/media/calendar_img.dae0c5025cd548366390c328392f2b50.svg";
export { ForwardRef as ReactComponent };